/* RESPONSIBLE TEAM: team-pricing-and-packaging */
import Price from './price';

export default class MigrationEstimate extends Price {}
